<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid :id="reportName+'_list'" class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<div class="full" style="position: relative;height: 500px;width: 50%;margin-top: 20px;">
			<supplierincrement />
		</div>


	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportMixins from '@_system/components/base/mixins/list/export.js'
	import exportTable from '@_system/components/export/index.vue'
	import supplierincrement from './lib/supplierincrement.vue'
	export default {
		mixins: [reportBase, exportMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				// footerField: [{
				// 	type: 'seq',
				// 	field: 'code',
				// 	title: '汇总',
				// }, {
				// 	type: 'field',
				// 	field: 'num',
				// 	toFixed: 1
				// }, {
				// 	type: 'field',
				// 	field: 'preamount',
				// 	toFixed: 4
				// }, {
				// 	type: 'field',
				// 	field: 'amount',
				// 	toFixed: 4
				// }],
				reportName: 'reconciliation',
				windowName: '付款审核统计',
				showFooter: false,
				exportRef: Math.random(),
				pagerConfig: {
					enabled: false,
				},
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns,gridOptions){
				gridOptions.maxHeight=400
			}
		},
		components: {
			exportTable,
			supplierincrement
		}
	}
</script>